import AppContainerWrapper from "../components/AppContainerWrapper";
import GlobalLoading from "../components/GlobalLoading";
import useMeasure from "../hooks/useMeasure";
import { useAppSelector } from "../redux/hooks";
import BreadcrumbsComponent from "./BreadcrumbsComponent";
import { Footer } from "./Footer";
import GlobalToast from "./GlobalToast";
import LoadingPage from "./LoadingPage";
import NavbarPersistWrapper from "./Navbar/NavbarPersistWrapper";

const Layout = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  return (
    <div className="h-screen w-full">
      <GlobalLoading />
      <MainComponent children={children} />
      <GlobalToast />
    </div>
  );
};

const MainComponent = ({ children }: any) => {
  const { ref, size, windowSize } = useMeasure();

  const {
    auth: { token },
    user: { isLoadingUser },
  } = useAppSelector((state) => ({
    auth: state.auth,
    user: state.user,
  }));

  const height = windowSize.height - size.height - 64;

  if (!token) {
    return <>{children}</>;
  }
  return (
    <NavbarPersistWrapper>
      <BreadcrumbsComponent />
      <AppContainerWrapper style={{ minHeight: height }}>
        {isLoadingUser ? <LoadingPage /> : children}
      </AppContainerWrapper>
      <div ref={ref}>
        <Footer />
      </div>
    </NavbarPersistWrapper>
  );
};

export default Layout;
